module.exports = __webpack_public_path__ + "mc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/mc.svg
// module id = 933
// module chunks = 0